
const projectsList = [

    {
        name: 'Huddle',
        description: 'Landing page for a social media site.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/huddle1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/huddle2.png",
        live: "https://zippy-car.surge.sh/",
        sample: "https://github.com/SJellen/huddle",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Single Card',
        description: 'A single card design for a subscription service.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/singleCard1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/singleCard2.png",
        live: "http://complete-wish.surge.sh/",
        sample: "https://github.com/SJellen/singlePrice",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Four Cards',
        description: 'A four card website design.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/fourCard1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/fourCard2.png",
        live: "https://abiding-plant.surge.sh/",
        sample: "https://github.com/SJellen/fourCard",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Home Heating Company',
        description: 'A redesign of a company\'s website with an added dark mode version.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/churchills.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/churchill2.png",
        live: "http://homely-bikes.surge.sh",
        sample: "https://github.com/SJellen/chuchills",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    
    {
        name: 'Fylo',
        description: 'Landing page for a file sharing site.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/fyloLpss2.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/fyloLpss1.png",
        live: "http://smelly-street.surge.sh/",
        sample: "https://github.com/SJellen/fyloLP",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Huddle Landing Page',
        description: 'Landing page for a social media App.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/HuddleLP2.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/HuddleLP2mobile.png",
        live: "https://blue-eyed-humor.surge.sh/",
        sample: "https://github.com/SJellen/huddleLP",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Excursion',
        description: 'Discover hidden places in the world around you.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/camp.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/excursion2.png",
        live: "https://snotty-actor.surge.sh/",
        sample: "https://github.com/SJellen/excursion",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Base Apparel',
        description: 'Sign-up page for soon to open store.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/baseApparel1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/baseApparel2.png",
        live: "https://combative-soap.surge.sh/",
        sample: "https://github.com/SJellen/baseApparel",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Project Tracker',
        description: 'Landing page for a team project tracker.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/projectT1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/projectT2.png",
        live: "https://omniscient-stove.surge.sh/",
        sample: "https://github.com/SJellen/project-tracking",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Ping',
        description: 'Responsive page for Ping service.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/ping1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/ping2.png",
        live: "https://enchanting-planes.surge.sh",
        sample: "https://github.com/SJellen/ping",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Github API',
        description: 'Github userpage using Github API.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/githubAPI1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/githubAPI2.png",
        live: "https://jagged-leather.surge.sh/",
        sample: "https://github.com/SJellen/githubApi",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'JS Clock',
        description: 'A Javascript clock.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/JSclock.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/JSclock.png",
        live: "https://js-clock-two.now.sh/",
        sample: "https://github.com/SJellen/JSclock",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'United States GDP',
        description: 'A bar chart on US GDP using D3.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/usGDP.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/usGDP.jpg",
        live: "https://us-gdp-bar.vercel.app/",
        sample: "https://github.com/SJellen/US-GDP-bar",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Climate Change Deaths',
        description: 'A bar chart on climate change deaths using D3.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/climateChange.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/climateChange.jpg",
        live: "https://climate-change-burden.vercel.app/",
        sample: "https://github.com/SJellen/climateChangeBurden",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Doping in Cycling',
        description: 'A scatterplot about doping using D3.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/bikeDoping.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/bikeDoping.jpg",
        live: "https://bike-doping.vercel.app/",
        sample: "https://github.com/SJellen/bikeDoping",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Monthly Global Temps',
        description: 'Monthly Global Surface Land Temps using D3.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/monthlyGlobal.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/monthlyGlobal.jpg",
        live: "https://global-temp.vercel.app/",
        sample: "https://github.com/SJellen/globalTemp",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'JsCSS',
        description: 'Using Javascript to control Css inputs.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/jsCss.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/jsCss.png",
        live: "https://js-css.now.sh/",
        sample: "https://github.com/SJellen/JsCSS",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Sign-up Form',
        description: 'Sign-up form with JS validation',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/signup1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/signup2.png",
        live: "https://steady-texture.surge.sh/",
        sample: "https://github.com/SJellen/signup-form",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Insure LP',
        description: 'Landing page for an insurance company',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/insureLP1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/insureLP2.png",
        live: "https://venomous-detail.surge.sh/",
        sample: "https://github.com/SJellen/insureLP",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Clipboard LP',
        description: 'Landing page for Clipboard App.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/clipboardlp.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/clipboardlp2.png",
        live: "https://clipboard-lp-1o9eiobi4.now.sh/",
        sample: "https://github.com/SJellen/clipboardLP",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Huddle LP2',
        description: 'Landing page for Huddle App.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/huddleLP-1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/huddleLP2-2.png",
        live: "https://github.com/SJellen/huddleLP2",
        sample: "https://huddle-lp-2.now.sh/",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Fylo Dark',
        description: 'A dark version of Fylo\'s landing page.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/fyloDark1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/fyloDark2.png",
        live: "https://fylo-dark-nine.now.sh/",
        sample: "https://github.com/SJellen/fyloDark",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Pricing Component',
        description: 'A pricing component for a service site.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/pricing1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/pricing2.png",
        live: "https://pricing-component-sand.now.sh/",
        sample: "https://github.com/SJellen/pricingComponent",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    // {
    //     name: 'Jammming',
    //     description: 'A Spotify playlist creator',
    //     img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/jammming1.png",
    //     img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/jammming2.png",
    //     live: "https://jammming.sjellen.now.sh/",
    //     sample: "https://github.com/SJellen/jammming",
    //     htmlLogo: true,
    //     cssLogo: true,
    //     sass: false,
    //     jsLogo: true,
    //     b4Logo: false,
    //     react: true,
    //     node: false
    // },
    {
        name: 'Character Study',
        description: 'Travels of fictional characters through different forms of media.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/csimg3.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/cStudy2.png",
        live: "https://keen-turing-1797a8.netlify.app/",
        sample: "https://github.com/SJellen/cStudySample",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: true,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Duck Duck... Hunt!',
        description: 'Hunt the duck across multiple environments.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/duckduck1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/duckduck2.png",
        live: "https://duck-duck-hunt.now.sh/",
        sample: "https://github.com/SJellen/DuckDuckHunt",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Die Hard Quoter',
        description: 'A Die Hard quote generator.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/dieHardQuote1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/dieHardQuote2.png",
        live: "https://die-hard-quote.now.sh/",
        sample: "https://github.com/SJellen/DieHardQuote",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Random Programming Quoter',
        description: 'A programming quote generator.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/randomQuote2.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/randomQuote1.jpg",
        live: "https://random-quote-tau.vercel.app/",
        sample: "https://github.com/SJellen/random-quote",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    
    {
        name: 'Shortly',
        description: 'Page for a link shortener service.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/shortly1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/shortly2.png",
        live: "https://shortly-flax.now.sh/",
        sample: "https://github.com/SJellen/Shortly",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'EasyBank',
        description: 'Landing page for Easybank.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/easybank1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/easybank2.png",
        live: "https://easybank.now.sh/",
        sample: "https://github.com/SJellen/easybank",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Movie Love TweetBot',
        description: 'A Tweetbot that favorites and retweets classic movie and Criterion Channel media.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/movieLove1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/movieLove2.png",
        live: "https://twitter.com/DieHard96347392",
        sample: "https://github.com/SJellen/MovieLoveSample",
        htmlLogo: false,
        cssLogo: false,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: true,
        express: false,
        mongoDB: false
    },
    {
        name: 'ManageLP',
        description: 'Landing page for the service Manage.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/manageLP1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/manageLP2.png",
        live: "https://manage-lp.now.sh/",
        sample: "https://github.com/SJellen/manageLP",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Meal Mixer',
        description: 'A random meal generator.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/mealMixer1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/mealMixer2.png",
        live: "https://meal-mixer.now.sh/",
        sample: "https://github.com/SJellen/Meal-Mixer",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'JSCal',
        description: 'A Javascipt calculator.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/JScal1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/JScal2.jpg",
        live: "https://js-cal-tau.vercel.app/",
        sample: "https://github.com/SJellen/JScal",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Drum Kit',
        description: 'A keyboard drum kit.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/drumkit1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/drumkit1.png",
        live: "https://drumkit-azure.now.sh",
        sample: "https://github.com/SJellen/Drumkit",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'BookmarkLP',
        description: 'Landing page for the service Bookmark.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/bookmarkLP1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/bookmarkLP2.png",
        live: "https://bookmark-lp.now.sh/",
        sample: "https://github.com/SJellen/bookmarkLP",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Social Media Dashboard',
        description: 'A dashboard for all your social media.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/socialMedia1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/socialMedia2.png",
        live: "https://social-media-dashboard.sjellen.now.sh/",
        sample: "https://github.com/SJellen/socialMediaDashboard",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Static Job Listing',
        description: 'A job listing selector.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/staticJob1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/staticJob2.png",
        live: "https://static-job-listings-nine.now.sh/",
        sample: "https://github.com/SJellen/staticJobListings",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Pocket Drum Machine',
        description: 'A drum machine in React.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/pocketDrum1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/pocketDrum2.jpg",
        live: "https://drum-machine-xi.vercel.app/",
        sample: "https://github.com/SJellen/drum-machine",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },

    {
        name: 'Markdown Previewer',
        description: 'A markdown previewer in React.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/markdown1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/markdown2.jpg",
        live: "https://markdown-pearl.vercel.app/",
        sample: "https://github.com/SJellen/markdown",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Pomodoro Timer',
        description: 'A pomodoro timer in React.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/pomodoro1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/pomodoro2.jpg",
        live: "https://pomodoro-beta.vercel.app/",
        sample: "https://github.com/SJellen/pomodoro",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Terminal Video',
        description: 'Movie search with the OMDB API.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/terminalVideo1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/terminalVideo2.png",
        live: "https://terminal-video.now.sh/",
        sample: "https://github.com/SJellen/terminal-video",
        htmlLogo: false,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Another Thing Todo',
        description: 'A simple React Todo list.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/anotherThing1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/anotherThing2.jpg",
        live: "https://another-thing-todo.vercel.app/",
        sample: "https://github.com/SJellen/another-thing-todo",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Star Wars Films',
        description: 'Film data from the Star Wars API.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/SWAPI1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/SWAPI2.png",
        live: "https://swapi-films.now.sh/",
        sample: "https://github.com/SJellen/Swapi-films",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Census 2020',
        description: 'Census form in React.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/census1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/census2.png",
        live: "https://census2020.now.sh/",
        sample: "https://github.com/SJellen/Census2020",
        htmlLogo: false,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    }, 
    {
        name: 'Meme Generator',
        description: 'Meme Generator using the Imgflip API',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/meme1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/meme2.png",
        live: "https://meme-eight.now.sh/",
        sample: "https://github.com/SJellen/Meme",
        htmlLogo: false,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Food Finder',
        description: 'Search for the best foods with the Yelp Api.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/foodFinder1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/foodFinder2.png",
        live: "https://foodfinder.now.sh/",
        sample: "https://github.com/SJellen/food_finder_sample",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Speed Typer `85',
        description: 'A speed typing game with local storage highscore.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/speedTyper1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/speedTyper2.png",
        live: "https://speedtype.now.sh/",
        sample: "https://github.com/SJellen/speedtype",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Bookmark Homepage',
        description: 'Homepage to centralize bookmarks across browsers. ',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/bookmarkHomepage1.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/bookmarkHomepage2.png",
        live: "https://bookmark-page-six.vercel.app/",
        sample: "https://github.com/SJellen/bookmark-page",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Chat App',
        description: 'A cell phone designed in Sass',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/chatApp1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/chatApp2.jpg",
        live: "https://chat-app-beta.vercel.app/",
        sample: "https://github.com/SJellen/chat-app",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Sunnyside',
        description: 'A landing page for Sunnyside agency.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/sunnyside.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/sunnysideMobile.png",
        live: "https://sunnyside-mu.vercel.app/",
        sample: "https://github.com/SJellen/sunnyside",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: false,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Weather Widget',
        description: 'A weather widget using Open Weather API.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/weather1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/weather2.jpg",
        live: "https://cocky-spence-832819.netlify.app/",
        sample: "https://github.com/SJellen/weather",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Media Shelf',
        description: 'A page of my media consumption with reviews ',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/myMedia1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/myMedia2.jpg",
        live: "https://my-media.vercel.app//",
        sample: "https://github.com/SJellen/my-media",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'NASA Navigator',
        description: 'A page for searching NASA\'s image API.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/nasaNav1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/nasaNav2.jpg",
        live: "https://nasa-pic-board.vercel.app/",
        sample: "https://github.com/SJellen/nasa-pic-board",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Harvard Art Museum Explorer',
        description: 'Explore the images, video and audio of the Harvard Art API',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/harvard1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/harvard2.jpg",
        live: "https://harvard-gallery.vercel.app/",
        sample: "https://github.com/SJellen/harvard-gallery",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Rick and Morty Dead or Alive',
        description: 'A Rick and Morty dead or alive game using the Rick and Morty API',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/rm1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/rm2.jpg",
        live: "https://rm-doa.vercel.app/",
        sample: "https://github.com/SJellen/rm-doa",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Screening',
        description: 'An IMDB clone using TMDB API.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/screening1.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/screening2.jpg",
        live: "https://affectionate-tesla-9555b9.netlify.app/",
        sample: "https://github.com/SJellen/screening",
        htmlLogo: false,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: true,
        express: false,
        mongoDB: false
    },
    {
        name: 'To The Moon',
        description: 'A Wallstreetbets dashboard with a ticker, news and Twitter reaction.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/toTheMoon.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/toTheMoon2.jpg",
        live: "https://tothemoon2.vercel.app/",
        sample: "https://github.com/SJellen/tothemooncode",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: false,
        b4Logo: true,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'The Planets',
        description: 'Fact sheets for all the planets in the solar system.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/planetFactSheet.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/planetFactSheetMobile.png",
        live: "https://planets-fact-site-five.vercel.app/",
        sample: "https://github.com/SJellen/planets-fact-site",
        htmlLogo: true,
        cssLogo: true,
        sass: false,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'Coffee Roasters',
        description: 'A subscription site for a coffee bean company.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/coffeeRoasters.jpg",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/coffeeRoastersMobile.jpg",
        live: "https://coffee-roasters-virid.vercel.app/",
        sample: "https://github.com/SJellen/coffee-roasters",
        htmlLogo: false,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    {
        name: 'General Knowledge',
        description: 'A quiz show game with multiple rounds and a final round bidding system.',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/generalKnowledge.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/generalKnowledgeMobile.png",
        live: "https://generalknowledge.vercel.app/",
        sample: "",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },

    {
        name: 'Audiophile E-commerce',
        description: 'An E-commerce site for an audio product\'s company. ',
        img: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/audiophile.png",
        img2: "https://s3.us-east-2.amazonaws.com/scottjellen.me.projectlist/audiophileMobile.png",
        live: "https://audiophile-ecommerce-tau.vercel.app/",
        sample: "https://github.com/SJellen/audiophile-ecommerce",
        htmlLogo: false,
        cssLogo: false,
        sass: true,
        jsLogo: true,
        b4Logo: false,
        react: true,
        node: false,
        express: false,
        mongoDB: false
    },
    


    


  /*   {
        name: '',
        description: '',
        img: "",
        img2: "",
        live: "",
        sample: "",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: ""
    },
    {
        name: '',
        description: '',
        img: "",
        img2: "",
        live: "",
        sample: "",
        htmlLogo: true,
        cssLogo: false,
        sass: true,
        jsLogo: false,
        b4Logo: false,
        react: false,
        node: ""
    },

*/







]
projectsList.reverse()


export default projectsList